"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Llama = void 0;
var vpt_abr_network_estimator_1 = require("@sky-uk-ott/vpt-abr-network-estimator");
var abr_types_1 = require("../../abr-types");
var Llama = /** @class */ (function () {
    function Llama(logger, bandwidthEstimator, customConfig) {
        if (customConfig === void 0) { customConfig = {}; }
        this.bandwidthEstimator = bandwidthEstimator;
        this.shouldWaitForBandwidth = true;
        this.tracksAscending = [];
        this.logger = logger.withContext('LLAMA');
        this.logger.verbose('Received config: ', customConfig);
        var defaultConfig = {
            switchUpSmoother: {
                type: vpt_abr_network_estimator_1.SmootherType.HARMONIC_MEAN,
            },
            switchDownSmoother: { type: vpt_abr_network_estimator_1.SmootherType.LAST_SAMPLE },
        };
        this.config = {
            switchUpSmoother: __assign(__assign({}, defaultConfig.switchUpSmoother), customConfig.switchUpSmoother),
            switchDownSmoother: __assign(__assign({}, defaultConfig.switchDownSmoother), customConfig.switchDownSmoother),
        };
        this.logger.info('Using config: ', this.config);
        this.switchDownSmoother = this.bandwidthEstimator.getSmoother(this.config.switchDownSmoother);
        this.switchUpSmoother = this.bandwidthEstimator.getSmoother(this.config.switchUpSmoother);
    }
    Object.defineProperty(Llama.prototype, "name", {
        get: function () {
            return abr_types_1.AbrType.LLAMA;
        },
        enumerable: false,
        configurable: true
    });
    Llama.prototype.getRecommendedTracks = function () {
        if (!this.tracksAscending.length) {
            return null;
        }
        var selectedTrack = this.chooseTracks();
        this.lastTrack = selectedTrack;
        return selectedTrack;
    };
    Llama.prototype.setTracksAscending = function (tracksAscending) {
        this.tracksAscending = tracksAscending;
    };
    Llama.prototype.notifiedPlaybackRateChange = function () {
        // noop
    };
    Llama.prototype.destroy = function () {
        this.switchDownSmoother.unregister();
        this.switchUpSmoother.unregister();
    };
    Llama.prototype.chooseTracks = function () {
        var lowestTrack = this.tracksAscending[0];
        var tracksDescending = __spreadArray([], this.tracksAscending, true).reverse();
        var switchDownBandwidth = this.switchDownSmoother.getValue();
        var switchUpBandwidth = this.switchUpSmoother.getValue();
        // Assigning this variable fixes some TS quirks of undefined checking
        var currentTrack = this.lastTrack;
        // Scenario 1 - No "last track"
        // If we don't know what the last selected track is, let's take the lower
        // of the two bandwidth estimates and pick a track accordingly
        if (!currentTrack) {
            var conservativeEstimate_1 = Math.min(switchDownBandwidth, switchUpBandwidth);
            var match = tracksDescending.find(function (t) { return t.combinedBandwidth <= conservativeEstimate_1; });
            return match || lowestTrack;
        }
        // Scenario 2 - Switch Down estimate is lower than the currently playing track
        if (switchDownBandwidth < currentTrack.combinedBandwidth) {
            var switchDownTrack = tracksDescending.find(function (t) { return t.combinedBandwidth < currentTrack.combinedBandwidth; });
            return switchDownTrack || lowestTrack;
        }
        var switchUpTrack = this.tracksAscending.find(function (t) { return t.combinedBandwidth > currentTrack.combinedBandwidth; });
        // Scenario 3 - We have enough bandwidth to move up to the next track
        if (switchUpTrack && switchUpBandwidth >= switchUpTrack.combinedBandwidth) {
            return switchUpTrack;
        }
        // Scenario 4 - Stay on the same track if possible, otherwise move to the closest one down
        return tracksDescending.find(function (t) { return t.combinedBandwidth <= currentTrack.combinedBandwidth; }) || lowestTrack;
    };
    return Llama;
}());
exports.Llama = Llama;
